export default "__VITE_ASSET__THEVMIwq__"